import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import styles from './style.module.css';
import Heading from '../../components/Heading';

const testimonials = [
  {
    quote: `As a property manager, I want a system that is a valuable amenity for tenants and is as hands-off as possible for me and my staff. BreatheEV handles all things charging so I can focus on our tenants and leasing.`,
    author: 'Carla R.',
  },
  {
    quote: `The reservation system makes charging way simpler for me to charge compared to the other chargers I have used before.`,
    author: 'Ashley Z.',
  },
  {
    quote: `I used to have to drive 30 minutes from my apartment, wait 30 minutes to charge and come back. Reserved charging, at my apartment, makes life so much easier.`,
    author: 'Tyler C.',
  },
];

const TestimonialsCarousel: React.FC = () => {
  const [index, setIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#testimonials') {
      const el = document.getElementById('testimonials');
      if (el) {
        setTimeout(() => {
          const offsetTop = el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: offsetTop - 100, // scroll to 500px before the element
            behavior: 'smooth',
          });
        }, 100); // small delay to ensure the DOM is ready
      }
    }
  }, [location]);
  

  return (
    <section className={`${styles.testimonialSection} testimonials`}>
      <span id="testimonials" className={`${styles.badge}`}>
        Testimonials
      </span>
      <Heading topBottomMargin={14}>What Our Partners Say</Heading>
      <p className={`mb-4 ${styles.subText}`}>
        Hear from property managers and business owners who have transformed their parking assets
        with BreatheEV’s reservation-enabled charging solutions.
      </p>

      <Carousel
        controls={false}
        interval={3000}
        slide
        className={styles.carousel}
        activeIndex={index}
        onSelect={(selectedIndex) => setIndex(selectedIndex)}
      >
        {testimonials.map((t, idx) => (
          <Carousel.Item key={idx}>
            <blockquote className={`blockquote mb-4 ${styles.quoteBox}`}>
              <p className={`${styles.quote}`}>"{t.quote}"</p>
              <div className={`blockquote-footer mt-3 ${styles.author}`}>{t.author}</div>
            </blockquote>
          </Carousel.Item>
        ))}
      </Carousel>

      <div className={styles.customControls}>
        <button
          className={styles.controlBtn}
          onClick={() => setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1))}
        >
          ‹
        </button>
        <button
          className={styles.controlBtn}
          onClick={() => setIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1))}
        >
          ›
        </button>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
